export default "__VITE_ASSET__C68RY6C3__"